const excludedSuppliers = ['10422', '10280', '10254', '10342', '10249', '10104', '10663', '10783'];
const excludedProductGroups = [
  '989',
  '991',
  '900',
  '740',
  '413',
  '747',
  '745',
  '746',
  '750',
  '770',
  '915',
  '931',
  '904',
  '936',
  '825',
  '748',
  '739',
  '1214',
  '1186',
  '739',
  '1219',
];
const excludedSkus = [
  '978730',
  '978732',
  '978731',
  '568875',
  '342343',
  '380127',
  '634202',
  '600937',
  '405919',
  '74007',
  '342276',
  '90169',
  '91286',
  '457362',
  '418544',
  '418955',
  '389351',
  '415339',
  '596042',
  '568636',
  '568858',
  '667541',
  '667549',
  '667553',
  '667557',
  '667561',
  '667546',
  '667550',
  '667569',
  '667542',
  '199863',
  '295250',
  '521283',
  '527065',
  '527070',
  '939423',
  '365590',
  '646724',
  '522837',
  '522830',
  '527062',
  '587673',
  '389355',
  '335665',
  '610775',
  '610751',
  '610776',
];
const eligibleDepartmentCodes = [
  '10',
  '15',
  '30',
  '35',
  '42',
  '46',
  '50',
  '55',
  '62',
  '65',
  '70',
  '75',
  '85',
  '90',
  '92',
  '100',
  '110',
  '20',
  '80',
];

const BIRTHDAY_COUPON_REFERENCE = 'JBPERKSBIRTHDAY';
const SIGNUP_COUPON_REFERENCE = 'JBPERKSSIGNUP';

export {
  excludedSuppliers,
  excludedProductGroups,
  excludedSkus,
  eligibleDepartmentCodes,
  BIRTHDAY_COUPON_REFERENCE,
  SIGNUP_COUPON_REFERENCE,
};
